import React from 'react';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

export type CustomToolbarProps = {
  title: string;
};

export const CustomToolbar = ({ title }: CustomToolbarProps) => {
  const classes = useStyles();

  return (
    <Typography variant="body1" className={classes.customToolbar}>
      {title}
    </Typography>
  );
};
